import { EErrorCode } from 'config/errors-codes';
import { errorCollection } from 'config/ui/error-collection';
export interface ICustomerFacingErrorOptions {
  message?: string;
  title?: string;
}
export class CustomerFacingError extends Error {
  code: EErrorCode;
  title: string;
  constructor(code: EErrorCode, options?: ICustomerFacingErrorOptions) {
    const message = options?.message || errorCollection[code]?.message().id || '';
    super(message);
    this.name = 'CustomerFacingError';
    this.code = code;
    this.title = options?.title || errorCollection[code]?.title().id || '';
    window?.E3D?.reportError(this);
  }
}
